import { render, staticRenderFns } from "./FinalizacoesDashUfi.vue?vue&type=template&id=d4b37b20"
import script from "./FinalizacoesDashUfi.vue?vue&type=script&lang=js"
export * from "./FinalizacoesDashUfi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports